export default __webpack_public_path__ + "static/media/level_two_badge.72a02c04.svg";